<template>
  <div class="consultoria-page">

    <!-- ─── NAVBAR ──────────────────────────────────────────────── -->
    <nav class="cg-nav">
      <div class="cg-nav-inner">
        <div class="cg-nav-logo" style="cursor:pointer" @click="$router.push('/landing')">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M13 2L3 14h8l-1 8 10-12h-8l1-8z" fill="#FF771C"/>
          </svg>
          <span class="cg-logo-text">Elev<span class="cg-logo-ment">Ment</span></span>
        </div>
        <ul class="cg-nav-links">
          <li><a href="#ofertas">{{ t('nav_ofertas') }}</a></li>
          <li><a href="#jornada">{{ t('nav_jornada') }}</a></li>
          <li><a href="#resultados">{{ t('nav_resultados') }}</a></li>
          <li><a href="#faq">FAQ</a></li>
        </ul>
        <div class="cg-nav-actions">
          <div class="cg-lang">
            <button :class="['cg-lang-btn', lang === 'PT' && 'cg-lang-active']" @click="setLang('PT')">PT</button>
            <button :class="['cg-lang-btn', lang === 'EN' && 'cg-lang-active']" @click="setLang('EN')">EN</button>
            <button :class="['cg-lang-btn', lang === 'ES' && 'cg-lang-active']" @click="setLang('ES')">ES</button>
          </div>
          <a class="cg-nav-entrar" @click="$router.push('/login')">{{ t('nav_login') }}</a>
          <button class="cg-btn-cta" @click="openDemo">{{ t('nav_cta') }}</button>
        </div>
      </div>
    </nav>

    <!-- ─── HERO ─────────────────────────────────────────────────── -->
    <section class="cg-hero">
      <div class="cg-hero-inner">
        <h1 class="cg-hero-title">
          {{ t('hero_title_1') }} <span class="cg-muted">{{ t('hero_title_2') }}</span>
          <span class="cg-orange"> {{ t('hero_title_3') }}</span><br>
          {{ t('hero_title_4') }}
        </h1>
        <p class="cg-hero-desc">{{ t('hero_desc') }}</p>
        <div class="cg-hero-btns">
          <button class="cg-btn-primary" @click="openDemo">{{ t('hero_cta') }}</button>
          <a href="#ofertas" class="cg-btn-ghost">{{ t('hero_ver') }}</a>
        </div>
        <div class="cg-hero-stacks">
          <span class="cg-stack-label">{{ t('hero_stacks_label') }}</span>
          <span class="cg-stack-tag">GITHUB</span>
          <span class="cg-stack-tag">COPILOT</span>
          <span class="cg-stack-tag">CODEX</span>
          <span class="cg-stack-tag">AZURE AI</span>
        </div>
      </div>
    </section>

    <!-- ─── STATS ────────────────────────────────────────────────── -->
    <section class="cg-stats">
      <div class="cg-stats-inner">
        <div class="cg-stat">
          <span class="cg-stat-val">55<span class="cg-stat-unit">%</span></span>
          <span class="cg-stat-desc">{{ t('stat1') }}</span>
        </div>
        <div class="cg-stat">
          <span class="cg-stat-val">3.4<span class="cg-stat-unit">x</span></span>
          <span class="cg-stat-desc">{{ t('stat2') }}</span>
        </div>
        <div class="cg-stat">
          <span class="cg-stat-val">40<span class="cg-stat-unit">%</span></span>
          <span class="cg-stat-desc">{{ t('stat3') }}</span>
        </div>
        <div class="cg-stat">
          <span class="cg-stat-val">2<span class="cg-stat-unit">sem</span></span>
          <span class="cg-stat-desc">{{ t('stat4') }}</span>
        </div>
      </div>
    </section>

    <!-- ─── OFERTAS ──────────────────────────────────────────────── -->
    <section id="ofertas" class="cg-ofertas">
      <div class="cg-ofertas-inner">
        <div class="cg-ofertas-header">
          <span class="cg-section-badge">{{ t('ofertas_badge') }}</span>
          <h2 class="cg-ofertas-title">{{ t('ofertas_title') }}</h2>
          <p class="cg-ofertas-desc">{{ t('ofertas_desc') }}</p>
        </div>
        <div class="cg-cards-grid">

          <div class="cg-card">
            <div class="cg-card-top">
              <span class="cg-card-cat">{{ t('cat1') }}</span>
            </div>
            <h3 class="cg-card-title">GitHub Enterprise Ready</h3>
            <p class="cg-card-desc">{{ t('c1_desc') }}</p>
            <ul class="cg-card-list">
              <li>{{ t('c1_li1') }}</li>
              <li>{{ t('c1_li2') }}</li>
              <li>{{ t('c1_li3') }}</li>
              <li>{{ t('c1_li4') }}</li>
            </ul>
          </div>

          <div class="cg-card">
            <div class="cg-card-top">
              <span class="cg-card-cat">{{ t('cat2') }}</span>
            </div>
            <h3 class="cg-card-title">GitHub Copilot Adoption</h3>
            <p class="cg-card-desc">{{ t('c2_desc') }}</p>
            <ul class="cg-card-list">
              <li>{{ t('c2_li1') }}</li>
              <li>{{ t('c2_li2') }}</li>
              <li>{{ t('c2_li3') }}</li>
              <li>{{ t('c2_li4') }}</li>
            </ul>
          </div>

          <div class="cg-card">
            <div class="cg-card-top">
              <span class="cg-card-cat">{{ t('cat3') }}</span>
            </div>
            <h3 class="cg-card-title">Codex &amp; Coding Agents</h3>
            <p class="cg-card-desc">{{ t('c3_desc') }}</p>
            <ul class="cg-card-list">
              <li>{{ t('c3_li1') }}</li>
              <li>{{ t('c3_li2') }}</li>
              <li>{{ t('c3_li3') }}</li>
              <li>{{ t('c3_li4') }}</li>
            </ul>
          </div>

          <div class="cg-card">
            <div class="cg-card-top">
              <span class="cg-card-cat">{{ t('cat4') }}</span>
            </div>
            <h3 class="cg-card-title">AI-Native Delivery Flow</h3>
            <p class="cg-card-desc">{{ t('c4_desc') }}</p>
            <ul class="cg-card-list">
              <li>{{ t('c4_li1') }}</li>
              <li>{{ t('c4_li2') }}</li>
              <li>{{ t('c4_li3') }}</li>
              <li>{{ t('c4_li4') }}</li>
            </ul>
          </div>

          <div class="cg-card">
            <div class="cg-card-top">
              <span class="cg-card-cat">{{ t('cat5') }}</span>
            </div>
            <h3 class="cg-card-title">AI Fluency para Devs &amp; PMs</h3>
            <p class="cg-card-desc">{{ t('c5_desc') }}</p>
            <ul class="cg-card-list">
              <li>{{ t('c5_li1') }}</li>
              <li>{{ t('c5_li2') }}</li>
              <li>{{ t('c5_li3') }}</li>
              <li>{{ t('c5_li4') }}</li>
            </ul>
          </div>

          <div class="cg-card">
            <div class="cg-card-top">
              <span class="cg-card-cat">{{ t('cat6') }}</span>
            </div>
            <h3 class="cg-card-title">AI Governance &amp; Security</h3>
            <p class="cg-card-desc">{{ t('c6_desc') }}</p>
            <ul class="cg-card-list">
              <li>{{ t('c6_li1') }}</li>
              <li>{{ t('c6_li2') }}</li>
              <li>{{ t('c6_li3') }}</li>
              <li>{{ t('c6_li4') }}</li>
            </ul>
          </div>

        </div>
      </div>
    </section>

    <!-- ─── JORNADA ──────────────────────────────────────────────── -->
    <section id="jornada" class="cg-jornada">
      <div class="cg-jornada-inner">
        <div class="cg-jornada-header">
          <div class="cg-jornada-left">
            <span class="cg-section-badge">{{ t('jornada_badge') }}</span>
            <h2 class="cg-jornada-title">
              {{ t('jornada_title_1') }} <span class="cg-orange">{{ t('jornada_title_2') }}</span>
            </h2>
          </div>
          <p class="cg-jornada-desc">{{ t('jornada_desc') }}</p>
        </div>
        <div class="cg-steps-row">
          <div class="cg-step">
            <span class="cg-step-num">01</span>
            <h4 class="cg-step-title">{{ t('step1_title') }}</h4>
            <p class="cg-step-desc">{{ t('step1_desc') }}</p>
          </div>
          <div class="cg-step">
            <span class="cg-step-num">02</span>
            <h4 class="cg-step-title">{{ t('step2_title') }}</h4>
            <p class="cg-step-desc">{{ t('step2_desc') }}</p>
          </div>
          <div class="cg-step">
            <span class="cg-step-num">03</span>
            <h4 class="cg-step-title">{{ t('step3_title') }}</h4>
            <p class="cg-step-desc">{{ t('step3_desc') }}</p>
          </div>
          <div class="cg-step">
            <span class="cg-step-num">04</span>
            <h4 class="cg-step-title">{{ t('step4_title') }}</h4>
            <p class="cg-step-desc">{{ t('step4_desc') }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- ─── CTA FINAL ────────────────────────────────────────────── -->
    <section id="agendar" class="cg-cta">
      <div class="cg-cta-inner">
        <div class="cg-cta-left">
          <span class="cg-cta-tag">{{ t('cta_tag') }}</span>
          <h2 class="cg-cta-title">{{ t('cta_title_1') }}<br><span class="cg-orange">{{ t('cta_title_2') }}</span></h2>
          <p class="cg-cta-desc">{{ t('cta_desc') }}</p>
        </div>
        <div class="cg-cta-btns">
          <button class="cg-btn-cta-lg" @click="openDemo">{{ t('cta_btn') }}</button>
          <a href="#ofertas" class="cg-btn-cta-outline">{{ t('cta_outline') }}</a>
        </div>
      </div>
    </section>

    <!-- Demo Dialog -->
    <div v-if="showDemoDialog" class="demo-overlay" @click.self="closeDemo">
      <div class="demo-dialog">
        <button class="demo-close" @click="closeDemo">&times;</button>

        <div v-if="demoSuccess" class="demo-success">
          <div class="demo-success-icon">✓</div>
          <h2 class="demo-dialog-title">{{ t('demo_success_title') }}</h2>
          <p class="demo-dialog-sub">{{ t('demo_success_sub') }}</p>
          <button class="demo-submit" @click="closeDemo">{{ t('demo_close') }}</button>
        </div>

        <template v-else>
          <h2 class="demo-dialog-title">{{ t('demo_title') }}</h2>
          <p class="demo-dialog-sub">{{ t('demo_sub') }}</p>

          <div v-if="demoError" class="demo-error-msg">{{ demoError }}</div>

          <div class="demo-field">
            <label>{{ t('demo_name') }}</label>
            <input v-model="demoForm.name" type="text" :placeholder="t('demo_name_ph')" maxlength="100" autocomplete="name" :disabled="demoLoading">
          </div>
          <div class="demo-field">
            <label>{{ t('demo_email') }}</label>
            <input v-model="demoForm.email" type="email" placeholder="email@empresa.com" maxlength="254" autocomplete="email" :disabled="demoLoading">
          </div>
          <div class="demo-field">
            <label>{{ t('demo_company') }}</label>
            <input v-model="demoForm.company" type="text" :placeholder="t('demo_company_ph')" maxlength="120" autocomplete="organization" :disabled="demoLoading">
          </div>
          <div class="demo-field">
            <label>{{ t('demo_phone') }}</label>
            <input v-model="demoForm.phone" type="tel" :placeholder="t('demo_phone_ph')" maxlength="15" autocomplete="tel" :disabled="demoLoading" @input="maskPhone">
          </div>
          <div class="demo-field">
            <label>{{ t('demo_team') }}</label>
            <select v-model="demoForm.teamSize" :disabled="demoLoading">
              <option value="">{{ t('demo_team_ph') }}</option>
              <option value="1-10">{{ t('demo_team1') }}</option>
              <option value="11-50">{{ t('demo_team2') }}</option>
              <option value="51-200">{{ t('demo_team3') }}</option>
              <option value="200+">{{ t('demo_team4') }}</option>
            </select>
          </div>
          <button class="demo-submit" :disabled="demoLoading" @click="submitDemo">
            <span v-if="demoLoading" class="demo-spinner"></span>
            {{ demoLoading ? t('demo_sending') : t('demo_submit') }}
          </button>
        </template>
      </div>
    </div>

    <!-- ─── FOOTER ───────────────────────────────────────────────── -->
    <footer class="cg-footer">
      <div style="display: flex; align-items: center; justify-content: center; gap: 40px; flex-wrap: wrap;">
        <img
          src="@/assets/images/founders.png"
          width="160"
          alt="ElevMent Founders"
          style="opacity: 0.85; object-fit: contain; transition: opacity 0.2s;"
          onmouseover="this.style.opacity='1'"
          onmouseout="this.style.opacity='0.85'"
        />
        <img
          src="@/assets/images/oracle.png"
          width="160"
          alt="Oracle Partnership"
          style="opacity: 0.85; object-fit: contain; transition: opacity 0.2s;"
          onmouseover="this.style.opacity='1'"
          onmouseout="this.style.opacity='0.85'"
        />
      </div>
      <p class="cg-footer-copy">&copy; {{ new Date().getFullYear() }} ElevMent. {{ t('footer') }}</p>
    </footer>

  </div>
</template>

<script>
import axios from 'axios'

const API_BASE_URL = process.env.VUE_APP_BACKEND_URL || 'http://localhost:8080'

function sanitize(str) {
  return String(str)
    .replace(/<[^>]*>/g, '')
    .replace(/[<>"'`]/g, '')
    .replace(/[\x00-\x1F\x7F]/g, '')
    .trim()
}

const FIELD_LIMITS = { name: 100, email: 254, company: 120, phone: 20 }

const CG_TR = {
  PT: {
    nav_ofertas: 'Ofertas', nav_jornada: 'Jornada', nav_resultados: 'Resultados',
    nav_login: 'Entrar', nav_cta: 'Agendar conversa',
    hero_title_1: 'Seu time pronto para', hero_title_2: 'codar com IA.',
    hero_title_3: 'Do Copilot ao Codex.', hero_title_4: 'No mesmo lugar.',
    hero_desc: 'Estruturamos GitHub, GitHub Copilot e agentes de código (Codex) em times de desenvolvimento e delivery — com governança, métricas e enablement real. Sem hype, com resultado mensurável.',
    hero_cta: 'Agendar conversa', hero_ver: 'Ver ofertas →', hero_stacks_label: 'PARCEIROS & STACKS',
    stat1: 'menos tempo em boilerplate', stat2: 'mais PRs mergeados por dev',
    stat3: 'menos bugs em produção', stat4: 'para o primeiro pilot rodando',
    ofertas_badge: 'OFERTAS', ofertas_title: 'Um programa de IA Adoption de ponta a ponta.',
    ofertas_desc: 'Seis frentes que combinam ferramenta, processo e pessoas — para que IA vire produtividade real no seu time de engenharia e delivery.',
    cat1: 'FUNDAÇÃO', cat2: 'PRODUTIVIDADE', cat3: 'AGENTES', cat4: 'DELIVERY', cat5: 'PESSOAS', cat6: 'GOVERNANÇA',
    c1_desc: 'Estruture o backbone de engenharia: org, branch protection, Actions, Advanced Security e governança de repositórios para escalar com IA.',
    c1_li1: 'Setup de org & RBAC', c1_li2: 'Branch policies & PR templates', c1_li3: 'Actions e CI/CD baseline', c1_li4: 'Advanced Security ativado',
    c2_desc: 'Programa de rollout do Copilot Business/Enterprise com enablement por squad, prompts internos e métricas de aceitação.',
    c2_li1: 'Pilot → rollout em ondas', c2_li2: 'Playbook de prompts por stack', c2_li3: 'Guardrails e políticas', c2_li4: 'Dashboard de adoção',
    c3_desc: 'Implante agentes de código (Codex, Copilot Workspace, agentes próprios) para refactors, testes e delivery autônomo de tarefas.',
    c3_li1: 'Backlog triagem por agente', c3_li2: 'Geração de testes & docs', c3_li3: 'Refactors guiados', c3_li4: 'Loop human-in-the-loop',
    c4_desc: 'Reescrita do fluxo de delivery com IA do discovery ao deploy: PRDs, breakdown, code review e release notes assistidos.',
    c4_li1: 'PRD & user stories com IA', c4_li2: 'Code review automatizado', c4_li3: 'Release notes & changelog', c4_li4: 'Métricas DORA + IA',
    c5_desc: 'Trilhas práticas para engenheiros, tech leads, PMs e EMs dominarem prompt engineering, agentes e novos workflows com IA.',
    c5_li1: 'Trilha por senioridade', c5_li2: 'Workshops hands-on', c5_li3: 'Certificação interna', c5_li4: 'Comunidade de práticas',
    c6_desc: 'Políticas, DLP, auditoria de prompts, controle de modelos e compliance para usar IA com segurança em código e dados sensíveis.',
    c6_li1: 'Política de uso de IA', c6_li2: 'Controle de modelos & dados', c6_li3: 'Auditoria de prompts', c6_li4: 'LGPD / ISO ready',
    jornada_badge: 'JORNADA', jornada_title_1: 'Do diagnóstico ao', jornada_title_2: 'delivery autônomo.',
    jornada_desc: 'Em 90 dias seu time sai do entusiasmo isolado para uma operação de IA escalável, segura e mensurável.',
    step1_title: 'Diagnóstico', step1_desc: 'Mapeamos maturidade em GitHub, IA e fluxo de delivery do seu time em 2 semanas.',
    step2_title: 'Piloto', step2_desc: 'Rodamos um pilot de Copilot + Codex em 1–2 squads com métricas claras de baseline.',
    step3_title: 'Rollout', step3_desc: 'Escalamos por ondas com enablement, playbooks e guardrails por stack.',
    step4_title: 'Operação', step4_desc: 'Acompanhamos adoção, ROI e evolução contínua dos agentes e workflows.',
    cta_tag: '↗ Conversa de 30 min · sem compromisso', cta_title_1: 'Pronto para tornar seu time', cta_title_2: 'AI-native?',
    cta_desc: 'Vamos entender seu contexto, mostrar cases reais com GitHub, Copilot e Codex e desenhar uma proposta de adoção sob medida.',
    cta_btn: 'Agendar conversa', cta_outline: 'Ver ofertas em detalhe',
    demo_title: 'Agendar uma demonstração', demo_sub: 'Preencha seus dados e entraremos em contato em até 24h.',
    demo_success_title: 'Solicitação enviada!', demo_success_sub: 'Entraremos em contato em até 24h pelo e-mail informado.',
    demo_close: 'Fechar', demo_name: 'Nome completo', demo_name_ph: 'Seu nome',
    demo_email: 'E-mail corporativo', demo_company: 'Empresa', demo_company_ph: 'Nome da empresa',
    demo_phone: 'Telefone', demo_phone_ph: '(00) 00000-0000', demo_team: 'Tamanho do time', demo_team_ph: 'Selecione',
    demo_team1: '1 - 10 pessoas', demo_team2: '11 - 50 pessoas', demo_team3: '51 - 200 pessoas', demo_team4: '200+ pessoas',
    demo_submit: 'Agendar demonstração', demo_sending: 'Enviando...',
    demo_err_required: 'Preencha todos os campos.', demo_err_email: 'Informe um e-mail válido.',
    demo_err_team: 'Selecione um tamanho de time válido.',
    demo_err_rate: 'Aguarde alguns segundos antes de tentar novamente.',
    demo_err_timeout: 'A requisição demorou demais. Verifique sua conexão e tente novamente.',
    demo_err_dup: 'Já recebemos sua solicitação. Entraremos em contato em breve.',
    demo_err_rate_limit: 'Muitas solicitações. Tente novamente em alguns minutos.',
    demo_err_generic: 'Erro ao enviar solicitação. Tente novamente.',
    footer: 'Todos os direitos reservados.',
  },
  EN: {
    nav_ofertas: 'Offerings', nav_jornada: 'Journey', nav_resultados: 'Results',
    nav_login: 'Sign in', nav_cta: 'Schedule a call',
    hero_title_1: 'Your team ready to', hero_title_2: 'code with AI.',
    hero_title_3: 'From Copilot to Codex.', hero_title_4: 'All in one place.',
    hero_desc: 'We structure GitHub, GitHub Copilot and coding agents (Codex) for development and delivery teams — with real governance, metrics and enablement. No hype, measurable results.',
    hero_cta: 'Schedule a call', hero_ver: 'See offerings →', hero_stacks_label: 'PARTNERS & STACKS',
    stat1: 'less time on boilerplate', stat2: 'more PRs merged per dev',
    stat3: 'fewer bugs in production', stat4: 'to get the first pilot running',
    ofertas_badge: 'OFFERINGS', ofertas_title: 'An end-to-end AI Adoption program.',
    ofertas_desc: 'Six fronts combining tools, process and people — so AI turns into real productivity for your engineering and delivery team.',
    cat1: 'FOUNDATION', cat2: 'PRODUCTIVITY', cat3: 'AGENTS', cat4: 'DELIVERY', cat5: 'PEOPLE', cat6: 'GOVERNANCE',
    c1_desc: 'Set up the engineering backbone: org, branch protection, Actions, Advanced Security and repo governance to scale with AI.',
    c1_li1: 'Org & RBAC setup', c1_li2: 'Branch policies & PR templates', c1_li3: 'Actions & CI/CD baseline', c1_li4: 'Advanced Security enabled',
    c2_desc: 'Copilot Business/Enterprise rollout program with per-squad enablement, internal prompts and acceptance metrics.',
    c2_li1: 'Pilot → wave rollout', c2_li2: 'Prompt playbook by stack', c2_li3: 'Guardrails & policies', c2_li4: 'Adoption dashboard',
    c3_desc: 'Deploy coding agents (Codex, Copilot Workspace, custom agents) for refactors, tests and autonomous task delivery.',
    c3_li1: 'Backlog triage by agent', c3_li2: 'Test & docs generation', c3_li3: 'Guided refactors', c3_li4: 'Human-in-the-loop',
    c4_desc: 'Rewrite the delivery flow with AI from discovery to deploy: assisted PRDs, breakdown, code review and release notes.',
    c4_li1: 'PRD & user stories with AI', c4_li2: 'Automated code review', c4_li3: 'Release notes & changelog', c4_li4: 'DORA + AI metrics',
    c5_desc: 'Practical tracks for engineers, tech leads, PMs and EMs to master prompt engineering, agents and new AI workflows.',
    c5_li1: 'Track by seniority', c5_li2: 'Hands-on workshops', c5_li3: 'Internal certification', c5_li4: 'Community of practice',
    c6_desc: 'Policies, DLP, prompt auditing, model control and compliance to use AI safely with code and sensitive data.',
    c6_li1: 'AI usage policy', c6_li2: 'Model & data control', c6_li3: 'Prompt auditing', c6_li4: 'GDPR / ISO ready',
    jornada_badge: 'JOURNEY', jornada_title_1: 'From diagnosis to', jornada_title_2: 'autonomous delivery.',
    jornada_desc: 'In 90 days your team goes from isolated enthusiasm to a scalable, secure and measurable AI operation.',
    step1_title: 'Diagnosis', step1_desc: 'We map GitHub, AI and delivery flow maturity in your team in 2 weeks.',
    step2_title: 'Pilot', step2_desc: 'We run a Copilot + Codex pilot in 1–2 squads with clear baseline metrics.',
    step3_title: 'Rollout', step3_desc: 'We scale in waves with enablement, playbooks and stack-specific guardrails.',
    step4_title: 'Operations', step4_desc: 'We track adoption, ROI and continuous evolution of agents and workflows.',
    cta_tag: '↗ 30-min call · no commitment', cta_title_1: 'Ready to make your team', cta_title_2: 'AI-native?',
    cta_desc: "We'll understand your context, show real cases with GitHub, Copilot and Codex and design a tailored adoption proposal.",
    cta_btn: 'Schedule a call', cta_outline: 'See offerings in detail',
    demo_title: 'Schedule a demo', demo_sub: 'Fill in your details and we will get back to you within 24h.',
    demo_success_title: 'Request sent!', demo_success_sub: 'We will contact you within 24h at the provided email.',
    demo_close: 'Close', demo_name: 'Full name', demo_name_ph: 'Your name',
    demo_email: 'Corporate email', demo_company: 'Company', demo_company_ph: 'Company name',
    demo_phone: 'Phone', demo_phone_ph: '(00) 00000-0000', demo_team: 'Team size', demo_team_ph: 'Select',
    demo_team1: '1 - 10 people', demo_team2: '11 - 50 people', demo_team3: '51 - 200 people', demo_team4: '200+ people',
    demo_submit: 'Schedule demo', demo_sending: 'Sending...',
    demo_err_required: 'Please fill in all fields.', demo_err_email: 'Please enter a valid email.',
    demo_err_team: 'Please select a valid team size.',
    demo_err_rate: 'Please wait a few seconds before trying again.',
    demo_err_timeout: 'Request timed out. Check your connection and try again.',
    demo_err_dup: 'We already received your request. We will be in touch shortly.',
    demo_err_rate_limit: 'Too many requests. Please try again in a few minutes.',
    demo_err_generic: 'Error sending request. Please try again.',
    footer: 'All rights reserved.',
  },
  ES: {
    nav_ofertas: 'Ofertas', nav_jornada: 'Jornada', nav_resultados: 'Resultados',
    nav_login: 'Entrar', nav_cta: 'Agendar conversación',
    hero_title_1: 'Tu equipo listo para', hero_title_2: 'codificar con IA.',
    hero_title_3: 'De Copilot a Codex.', hero_title_4: 'En el mismo lugar.',
    hero_desc: 'Estructuramos GitHub, GitHub Copilot y agentes de código (Codex) en equipos de desarrollo y delivery — con gobernanza, métricas y enablement real. Sin hype, con resultado medible.',
    hero_cta: 'Agendar conversación', hero_ver: 'Ver ofertas →', hero_stacks_label: 'SOCIOS & STACKS',
    stat1: 'menos tiempo en boilerplate', stat2: 'más PRs mergeados por dev',
    stat3: 'menos bugs en producción', stat4: 'para el primer pilot en marcha',
    ofertas_badge: 'OFERTAS', ofertas_title: 'Un programa de IA Adoption de punta a punta.',
    ofertas_desc: 'Seis frentes que combinan herramienta, proceso y personas — para que la IA se convierta en productividad real en tu equipo de ingeniería y delivery.',
    cat1: 'FUNDACIÓN', cat2: 'PRODUCTIVIDAD', cat3: 'AGENTES', cat4: 'DELIVERY', cat5: 'PERSONAS', cat6: 'GOBERNANZA',
    c1_desc: 'Estructura el backbone de ingeniería: org, branch protection, Actions, Advanced Security y gobernanza de repositorios para escalar con IA.',
    c1_li1: 'Setup de org & RBAC', c1_li2: 'Branch policies & PR templates', c1_li3: 'Actions y CI/CD baseline', c1_li4: 'Advanced Security activado',
    c2_desc: 'Programa de rollout de Copilot Business/Enterprise con enablement por squad, prompts internos y métricas de aceptación.',
    c2_li1: 'Pilot → rollout en ondas', c2_li2: 'Playbook de prompts por stack', c2_li3: 'Guardrails y políticas', c2_li4: 'Dashboard de adopción',
    c3_desc: 'Implementa agentes de código (Codex, Copilot Workspace, agentes propios) para refactors, tests y delivery autónomo de tareas.',
    c3_li1: 'Triaje de backlog por agente', c3_li2: 'Generación de tests & docs', c3_li3: 'Refactors guiados', c3_li4: 'Loop human-in-the-loop',
    c4_desc: 'Reescritura del flujo de delivery con IA del discovery al deploy: PRDs, breakdown, code review y release notes asistidos.',
    c4_li1: 'PRD & user stories con IA', c4_li2: 'Code review automatizado', c4_li3: 'Release notes & changelog', c4_li4: 'Métricas DORA + IA',
    c5_desc: 'Rutas prácticas para ingenieros, tech leads, PMs y EMs para dominar prompt engineering, agentes y nuevos workflows con IA.',
    c5_li1: 'Ruta por senioridad', c5_li2: 'Workshops hands-on', c5_li3: 'Certificación interna', c5_li4: 'Comunidad de prácticas',
    c6_desc: 'Políticas, DLP, auditoría de prompts, control de modelos y compliance para usar IA con seguridad en código y datos sensibles.',
    c6_li1: 'Política de uso de IA', c6_li2: 'Control de modelos & datos', c6_li3: 'Auditoría de prompts', c6_li4: 'LGPD / ISO ready',
    jornada_badge: 'JORNADA', jornada_title_1: 'Del diagnóstico al', jornada_title_2: 'delivery autónomo.',
    jornada_desc: 'En 90 días tu equipo pasa del entusiasmo aislado a una operación de IA escalable, segura y medible.',
    step1_title: 'Diagnóstico', step1_desc: 'Mapeamos madurez en GitHub, IA y flujo de delivery de tu equipo en 2 semanas.',
    step2_title: 'Piloto', step2_desc: 'Ejecutamos un pilot de Copilot + Codex en 1–2 squads con métricas claras de baseline.',
    step3_title: 'Rollout', step3_desc: 'Escalamos por ondas con enablement, playbooks y guardrails por stack.',
    step4_title: 'Operación', step4_desc: 'Acompañamos adopción, ROI y evolución continua de los agentes y workflows.',
    cta_tag: '↗ Conversación de 30 min · sin compromiso', cta_title_1: '¿Listo para hacer tu equipo', cta_title_2: 'AI-native?',
    cta_desc: 'Vamos a entender tu contexto, mostrar casos reales con GitHub, Copilot y Codex y diseñar una propuesta de adopción a medida.',
    cta_btn: 'Agendar conversación', cta_outline: 'Ver ofertas en detalle',
    demo_title: 'Agendar una demostración', demo_sub: 'Completa tus datos y te contactaremos en menos de 24h.',
    demo_success_title: '¡Solicitud enviada!', demo_success_sub: 'Nos pondremos en contacto en menos de 24h al correo proporcionado.',
    demo_close: 'Cerrar', demo_name: 'Nombre completo', demo_name_ph: 'Tu nombre',
    demo_email: 'Correo corporativo', demo_company: 'Empresa', demo_company_ph: 'Nombre de la empresa',
    demo_phone: 'Teléfono', demo_phone_ph: '(00) 00000-0000', demo_team: 'Tamaño del equipo', demo_team_ph: 'Selecciona',
    demo_team1: '1 - 10 personas', demo_team2: '11 - 50 personas', demo_team3: '51 - 200 personas', demo_team4: '200+ personas',
    demo_submit: 'Agendar demostración', demo_sending: 'Enviando...',
    demo_err_required: 'Completa todos los campos.', demo_err_email: 'Ingresa un correo válido.',
    demo_err_team: 'Selecciona un tamaño de equipo válido.',
    demo_err_rate: 'Espera unos segundos antes de intentar de nuevo.',
    demo_err_timeout: 'La solicitud tardó demasiado. Verifica tu conexión e intenta de nuevo.',
    demo_err_dup: 'Ya recibimos tu solicitud. Nos pondremos en contacto pronto.',
    demo_err_rate_limit: 'Demasiadas solicitudes. Intenta de nuevo en unos minutos.',
    demo_err_generic: 'Error al enviar la solicitud. Intenta de nuevo.',
    footer: 'Todos los derechos reservados.',
  },
}

export default {
  name: 'ConsultoriaPage',

  mounted() {
    window.scrollTo({ top: 0, behavior: 'instant' })
  },

  data: () => ({
    lang: 'PT',
    showDemoDialog: false,
    demoLoading: false,
    demoSuccess: false,
    demoError: '',
    demoForm: {
      name: '',
      email: '',
      company: '',
      phone: '',
      teamSize: '',
    },
    _demoLastSubmit: 0,
  }),

  methods: {
    t(key) {
      const tr = CG_TR[this.lang] || CG_TR.PT
      return tr[key] !== undefined ? tr[key] : (CG_TR.PT[key] || key)
    },
    setLang(l) {
      if (CG_TR[l]) this.lang = l
    },

    openDemo() {
      this.showDemoDialog = true
      this.demoSuccess = false
      this.demoError = ''
    },

    closeDemo() {
      this.showDemoDialog = false
      if (this.demoSuccess) {
        this.demoForm = { name: '', email: '', company: '', phone: '', teamSize: '' }
        this.demoSuccess = false
      }
      this.demoError = ''
    },

    maskPhone(e) {
      let v = e.target.value.replace(/\D/g, '').substring(0, 11)
      if (v.length > 6) {
        v = `(${v.substring(0, 2)}) ${v.substring(2, 7)}-${v.substring(7)}`
      } else if (v.length > 2) {
        v = `(${v.substring(0, 2)}) ${v.substring(2)}`
      } else if (v.length > 0) {
        v = `(${v}`
      }
      this.demoForm.phone = v
    },

    async submitDemo() {
      // Client-side rate limit: 30 s between submissions
      const now = Date.now()
      if (now - this._demoLastSubmit < 30_000) {
        this.demoError = this.t('demo_err_rate')
        return
      }

      // Sanitize & truncate all text fields
      const name     = sanitize(this.demoForm.name    ).substring(0, FIELD_LIMITS.name)
      const email    = sanitize(this.demoForm.email   ).substring(0, FIELD_LIMITS.email)
      const company  = sanitize(this.demoForm.company ).substring(0, FIELD_LIMITS.company)
      const phone    = sanitize(this.demoForm.phone   ).substring(0, FIELD_LIMITS.phone)
      const teamSize = this.demoForm.teamSize

      if (!name || !email || !company || !teamSize) {
        this.demoError = this.t('demo_err_required')
        return
      }
      if (!/^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/.test(email)) {
        this.demoError = this.t('demo_err_email')
        return
      }
      const VALID_TEAM_SIZES = ['1-10', '11-50', '51-200', '200+']
      if (!VALID_TEAM_SIZES.includes(teamSize)) {
        this.demoError = this.t('demo_err_team')
        return
      }

      this._demoLastSubmit = now
      this.demoLoading = true
      this.demoError = ''
      try {
        await axios.post(
          `${API_BASE_URL}/api/public/demo-requests`,
          { name, email, company, phone: phone || null, teamSize },
          { timeout: 10_000 },
        )
        this.demoSuccess = true
      } catch (err) {
        const status = err.response?.status
        if (err.code === 'ECONNABORTED') {
          this.demoError = this.t('demo_err_timeout')
        } else if (status === 409) {
          this.demoError = this.t('demo_err_dup')
        } else if (status === 429) {
          this.demoError = this.t('demo_err_rate_limit')
        } else {
          this.demoError = this.t('demo_err_generic')
        }
      } finally {
        this.demoLoading = false
      }
    },
  },
}
</script>

<style scoped>
/* ── Reset & Base ─────────────────────────────────────────────── */
* { box-sizing: border-box; margin: 0; padding: 0; }
.consultoria-page {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  background: #0A0A0B;
  color: #FFFFFF;
}
a { text-decoration: none; color: inherit; }
button { font-family: inherit; cursor: pointer; border: none; }

/* ── Nav ──────────────────────────────────────────────────────── */
.cg-nav {
  position: sticky;
  top: 0;
  z-index: 100;
  background: rgba(10,10,11,0.92);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(255,255,255,0.06);
}
.cg-nav-inner {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 32px;
  height: 60px;
  display: flex;
  align-items: center;
  gap: 40px;
}
.cg-nav-logo { display: flex; align-items: center; gap: 8px; text-decoration: none; user-select: none; cursor: pointer; flex-shrink: 0; }
.cg-logo-text { font-size: 18px; font-weight: 700; color: #FFFFFF; letter-spacing: -0.01em; }
.cg-logo-ment { color: rgba(255,255,255,0.45); }
.cg-nav-links {
  display: flex;
  gap: 28px;
  list-style: none;
  flex: 1;
}
.cg-nav-links a { font-size: 14px; color: rgba(255,255,255,0.55); transition: color .2s; }
.cg-nav-links a:hover { color: #FFFFFF; }
.cg-nav-actions { display: flex; align-items: center; gap: 14px; flex-shrink: 0; }
.cg-lang { display: flex; align-items: center; gap: 2px; background: rgba(255,255,255,0.07); border-radius: 6px; padding: 2px; }
.cg-lang-btn { font-size: 12px; font-weight: 600; color: rgba(255,255,255,0.45); background: none; border: none; cursor: pointer; padding: 4px 8px; border-radius: 4px; transition: all 0.15s; }
.cg-lang-active { background: #FF771C !important; color: #FFFFFF !important; }
.cg-nav-entrar { font-size: 14px; color: rgba(255,255,255,0.8); font-weight: 500; cursor: pointer; }
.cg-btn-cta {
  background: #FF771C;
  color: #fff;
  border-radius: 100px;
  padding: 8px 20px;
  font-size: 14px;
  font-weight: 600;
  transition: background .2s;
}
.cg-btn-cta:hover { background: #e5650d; }

/* ── Hero ─────────────────────────────────────────────────────── */
.cg-hero {
  background: #0A0A0B;
  padding: 100px 32px 80px;
  text-align: center;
  border-bottom: 1px solid rgba(255,255,255,0.06);
}
.cg-hero-inner { max-width: 760px; margin: 0 auto; }
.cg-hero-title {
  font-size: clamp(32px, 5vw, 56px);
  font-weight: 800;
  line-height: 1.1;
  color: #FFFFFF;
  letter-spacing: -0.02em;
  margin-bottom: 24px;
}
.cg-muted { color: rgba(255,255,255,0.35); }
.cg-orange { color: #FF771C; }
.cg-hero-desc {
  font-size: 16px;
  line-height: 1.7;
  color: rgba(255,255,255,0.52);
  max-width: 560px;
  margin: 0 auto 36px;
}
.cg-hero-btns { display: flex; align-items: center; justify-content: center; gap: 16px; margin-bottom: 48px; flex-wrap: wrap; }
.cg-btn-primary {
  background: #FF771C;
  color: #fff;
  border-radius: 100px;
  padding: 14px 28px;
  font-size: 15px;
  font-weight: 700;
  transition: background .2s;
}
.cg-btn-primary:hover { background: #e5650d; }
.cg-btn-ghost { font-size: 15px; color: rgba(255,255,255,0.6); font-weight: 500; }
.cg-btn-ghost:hover { color: #FFFFFF; }
.cg-hero-stacks {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}
.cg-stack-label { font-size: 11px; font-weight: 700; color: rgba(255,255,255,0.28); letter-spacing: 0.08em; }
.cg-stack-tag { font-size: 12px; font-weight: 700; color: rgba(255,255,255,0.4); letter-spacing: 0.06em; }

/* ── Stats ────────────────────────────────────────────────────── */
.cg-stats { background: #0A0A0B; padding: 48px 32px; border-top: 1px solid rgba(255,255,255,0.06); }
.cg-stats-inner {
  max-width: 900px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  text-align: center;
}
.cg-stat { display: flex; flex-direction: column; gap: 6px; }
.cg-stat-val { font-size: 42px; font-weight: 800; color: #FF771C; letter-spacing: -0.03em; line-height: 1; }
.cg-stat-unit { font-size: 28px; }
.cg-stat-desc { font-size: 13px; color: rgba(255,255,255,0.45); }

/* ── Ofertas ──────────────────────────────────────────────────── */
.cg-ofertas { background: #0A0A0B; padding: 80px 32px; border-top: 1px solid rgba(255,255,255,0.06); }
.cg-ofertas-inner { max-width: 1100px; margin: 0 auto; }
.cg-ofertas-header { margin-bottom: 48px; }
.cg-section-badge {
  font-size: 12px;
  font-weight: 700;
  color: #FF771C;
  letter-spacing: 0.1em;
  display: block;
  margin-bottom: 12px;
}
.cg-ofertas-title { font-size: clamp(28px, 4vw, 42px); font-weight: 800; line-height: 1.15; color: #FFFFFF; margin-bottom: 14px; }
.cg-ofertas-desc { font-size: 15px; color: rgba(255,255,255,0.45); max-width: 500px; line-height: 1.65; }
.cg-cards-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}
.cg-card {
  background: rgba(255,255,255,0.04);
  border-radius: 16px;
  padding: 28px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  border: 1px solid rgba(255,255,255,0.08);
  transition: background .2s;
}
.cg-card:hover { background: rgba(255,255,255,0.06); }
.cg-card-top { display: flex; align-items: center; justify-content: space-between; }
.cg-card-icon {
  width: 40px; height: 40px;
  background: rgba(255,119,28,0.1);
  border-radius: 10px;
  color: #FF771C;
  font-size: 16px;
  display: flex; align-items: center; justify-content: center;
  font-weight: 700;
}
.cg-card-cat { font-size: 11px; font-weight: 700; color: rgba(255,255,255,0.3); letter-spacing: 0.1em; }
.cg-card-title { font-size: 18px; font-weight: 700; color: #FFFFFF; }
.cg-card-desc { font-size: 13px; color: rgba(255,255,255,0.48); line-height: 1.6; }
.cg-card-list { list-style: none; display: flex; flex-direction: column; gap: 5px; margin-top: 4px; }
.cg-card-list li {
  font-size: 13px;
  color: rgba(255,255,255,0.6);
  padding-left: 18px;
  position: relative;
}
.cg-card-list li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: #FF771C;
  font-weight: 700;
}

/* ── Jornada ──────────────────────────────────────────────────── */
.cg-jornada { background: #0A0A0B; padding: 80px 32px; border-top: 1px solid rgba(255,255,255,0.06); }
.cg-jornada-inner { max-width: 1100px; margin: 0 auto; }
.cg-jornada-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 40px;
  margin-bottom: 48px;
  flex-wrap: wrap;
}
.cg-jornada-title { font-size: clamp(28px, 4vw, 44px); font-weight: 800; line-height: 1.1; margin-top: 12px; color: #FFFFFF; }
.cg-jornada-desc { font-size: 15px; color: rgba(255,255,255,0.45); max-width: 380px; line-height: 1.65; align-self: center; }
.cg-steps-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}
.cg-step {
  background: rgba(255,255,255,0.04);
  border-radius: 14px;
  padding: 24px;
  border: 1px solid rgba(255,255,255,0.08);
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.cg-step-num { font-size: 13px; font-weight: 700; color: #FF771C; }
.cg-step-title { font-size: 17px; font-weight: 700; color: #FFFFFF; }
.cg-step-desc { font-size: 13px; color: rgba(255,255,255,0.45); line-height: 1.6; }

/* ── CTA Final ────────────────────────────────────────────────── */
.cg-cta {
  background: rgba(255,255,255,0.03);
  border: 1px solid rgba(255,255,255,0.08);
  padding: 72px 32px;
  margin: 0 32px 64px;
  border-radius: 24px;
  position: relative;
  overflow: hidden;
}
.cg-cta::before {
  content: '';
  position: absolute;
  top: -80px; right: -80px;
  width: 320px; height: 320px;
  background: radial-gradient(circle, rgba(255,119,28,0.3) 0%, transparent 70%);
  pointer-events: none;
}
.cg-cta-inner {
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 48px;
  flex-wrap: wrap;
}
.cg-cta-tag {
  display: inline-block;
  background: rgba(255,119,28,0.15);
  border: 1px solid rgba(255,119,28,0.3);
  color: #FF9F43;
  border-radius: 100px;
  padding: 6px 14px;
  font-size: 13px;
  margin-bottom: 20px;
}
.cg-cta-title { font-size: clamp(24px, 3.5vw, 38px); font-weight: 800; color: #fff; line-height: 1.15; margin-bottom: 14px; }
.cg-cta-desc { font-size: 14px; color: rgba(255,255,255,0.48); line-height: 1.65; max-width: 440px; }
.cg-cta-btns { display: flex; flex-direction: column; gap: 12px; flex-shrink: 0; min-width: 240px; }
.cg-btn-cta-lg {
  background: #FF771C;
  color: #fff;
  border-radius: 10px;
  padding: 16px 28px;
  font-size: 15px;
  font-weight: 700;
  text-align: center;
  transition: background .2s;
}
.cg-btn-cta-lg:hover { background: #e5650d; }
.cg-btn-cta-outline {
  background: rgba(255,255,255,0.07);
  border: 1px solid rgba(255,255,255,0.15);
  color: #fff;
  border-radius: 10px;
  padding: 15px 28px;
  font-size: 15px;
  font-weight: 600;
  text-align: center;
  transition: background .2s;
}
.cg-btn-cta-outline:hover { background: rgba(255,255,255,0.12); }

/* ── Footer ───────────────────────────────────────────────────── */
.cg-footer {
  background: #060608;
  border-top: 1px solid rgba(255,255,255,0.06);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  padding: 40px 20px;
}
.cg-footer-copy { font-size: 13px; color: rgba(255,255,255,0.28); text-align: center; }

/* ── Demo Dialog ─────────────────────────────────────────────── */
.demo-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}
.demo-dialog {
  background: #1A1A1C;
  border: 1px solid rgba(255,255,255,0.12);
  border-radius: 16px;
  padding: 40px;
  max-width: 460px;
  width: 100%;
  position: relative;
  box-shadow: 0 24px 64px rgba(0,0,0,0.5);
}
.demo-close {
  position: absolute;
  top: 16px; right: 20px;
  background: none; border: none;
  font-size: 24px; color: rgba(255,255,255,0.4); cursor: pointer;
}
.demo-close:hover { color: #FFFFFF; }
.demo-dialog-title { font-size: 22px; font-weight: 700; margin-bottom: 6px; color: #FFFFFF; }
.demo-dialog-sub { font-size: 14px; color: rgba(255,255,255,0.5); margin-bottom: 28px; }
.demo-field { margin-bottom: 16px; }
.demo-field label { display: block; font-size: 13px; font-weight: 500; color: rgba(255,255,255,0.75); margin-bottom: 6px; }
.demo-field input,
.demo-field select {
  width: 100%; padding: 10px 14px;
  border: 1px solid rgba(255,255,255,0.12); border-radius: 8px;
  font-size: 14px; background: rgba(255,255,255,0.06); color: #FFFFFF;
  outline: none; transition: border-color .2s;
}
.demo-field input::placeholder { color: rgba(255,255,255,0.3); }
.demo-field select option { background: #1A1A1C; color: #FFFFFF; }
.demo-field input:focus,
.demo-field select:focus { border-color: #FF771C; }
.demo-submit {
  width: 100%; background: #FF771C; color: #fff;
  border: none; padding: 14px; border-radius: 10px;
  font-size: 15px; font-weight: 600; cursor: pointer;
  margin-top: 8px; transition: all .2s;
}
.demo-submit:hover:not(:disabled) { background: #E8691A; box-shadow: 0 4px 16px rgba(255,119,28,0.3); }
.demo-submit:disabled { opacity: .7; cursor: not-allowed; }
.demo-success { text-align: center; padding: 20px 0; }
.demo-success-icon {
  width: 56px; height: 56px; border-radius: 50%;
  background: #34C759; color: #fff;
  font-size: 28px; font-weight: 700;
  display: flex; align-items: center; justify-content: center;
  margin: 0 auto 20px;
}
.demo-error-msg {
  background: rgba(211,47,47,0.12); color: #FF6B6B;
  border: 1px solid rgba(211,47,47,0.3); border-radius: 8px;
  padding: 10px 14px; font-size: 13px; margin-bottom: 16px;
}
.demo-spinner {
  display: inline-block; width: 16px; height: 16px;
  border: 2px solid rgba(255,255,255,.3); border-top-color: #fff;
  border-radius: 50%; animation: demo-spin .6s linear infinite;
  margin-right: 8px; vertical-align: middle;
}
@keyframes demo-spin { to { transform: rotate(360deg); } }

/* ── Responsive ───────────────────────────────────────────────── */
@media (max-width: 900px) {
  .cg-cards-grid { grid-template-columns: 1fr 1fr; }
  .cg-steps-row { grid-template-columns: 1fr 1fr; }
  .cg-stats-inner { grid-template-columns: 1fr 1fr; }
  .cg-jornada-header { flex-direction: column; }
}
@media (max-width: 600px) {
  .cg-nav-links { display: none; }
  .cg-cards-grid { grid-template-columns: 1fr; }
  .cg-steps-row { grid-template-columns: 1fr; }
  .cg-stats-inner { grid-template-columns: 1fr 1fr; }
  .cg-cta-inner { flex-direction: column; }
  .cg-cta { margin: 0 16px 40px; padding: 48px 24px; }
}
</style>
